import React, { useEffect, useState } from 'react';
import { get, isEmpty, groupBy, isNull } from 'lodash';
import { ListItem, ListItemText, Grid } from '@material-ui/core';
import { fetchPerformanceRecord } from '../../../../actions/performanceRecordActions';
// Redux Imports
import { useDispatch, useSelector } from 'react-redux';
import AttendanceComponent from '../components/AttenanceComponent';
import { dateFormat } from '../../../../api/dateFormat';
import NoData from '../../../../components/NoData';
import { Skeleton } from '@material-ui/lab';
import LineGraphsSlider from '../components/LineGraphSlider';
// Style Imports
import './styles.scss';
//Images

export default function PrintPerformanceReport() {
  // State
  const [isFetching, setIsFetching] = useState(false);

  // Reducers
  const dispatch = useDispatch();
  const profile = useSelector((state) =>
    get(state, 'dashboardReducer.profileData', '')
  );
  const loginData = useSelector((state) =>
    get(state, 'loginReducer.data.jwt', {})
  );
  const ProfilePhoto = get(profile, 'profile[0].StudentPic', '');
  const FullName = get(profile, 'profile[0].FirstName', '');
  const personal = {
    ApplicationFormNo: get(profile, 'profile[0].EnrolmentNo', ''),
    Email: get(profile, 'profile[0].EmailiD', ''),
    Mobile: get(profile, 'profile[0].MobileNo', ''),
    DateOfBirth: get(profile, 'profile[0].DOB', '')
      ? dateFormat(get(profile, 'profile[0].DOB', ''))
      : '',
    CurrentSchool: get(profile, 'profile[0].CurrentSchool', ''),
  };
  const TableData = useSelector((state) =>
    get(state, 'performanceRecordReducer.data.attendance', [])
  );

  const TestPerformanceRecordData = useSelector((state) =>
    get(state, 'performanceRecordReducer.data.testRecord', {})
  );

  const ErrorMessage = useSelector((state) =>
    get(state, 'performanceRecordReducer.errorMessage', '')
  );

  const batch = {
    BatchName: get(profile, 'profile[0].BatchName', ''),
    Phase: get(profile, 'profile[0].SubClassTitle', ''),
    CourseName: get(profile, 'profile[0].CourseName', ''),
    CourseCode: get(profile, 'profile[0].CourseCode', ''),
    CampusName: get(profile, 'profile[0].CampusName', ''),
    CampusAddress: get(profile, 'profile[0].CampusAddress', ''),
  };
  const analysisGraph = useSelector((state) =>
    get(state, 'performanceRecordReducer.data.analysisGraph', [])
  );

  useEffect(() => {
    setIsFetching(true);
    fetchPerformanceRecord(loginData, dispatch).then(() => {
      setIsFetching(false);
    });
  }, [loginData]);

  useEffect(() => {
    setTimeout(function () {
      const header = document.getElementsByClassName('header');
      header[0].style.position = 'static';
      window.print();
      header[0].style.position = 'fixed';
    }, 2000);
  }, []);

  const populateFullTable = () => {
    let mainHeader = [],
      header = [],
      subHeader = [],
      details = [];
    const data = !isEmpty(TestPerformanceRecordData)
      ? TestPerformanceRecordData
      : [];
    data.main_header.map((x) => {
      let colspan = (get(x, 'header', []) || []).length;
      (get(x, 'header', []) || []).map((headerContent) => {
        colspan = colspan + (get(headerContent, 'sub_header', []) || []).length;
        header.push(
          <td
            colSpan={(get(headerContent, 'sub_header', []) || []).length}
            align="center"
          >
            {get(headerContent, 'value', '')}
          </td>
        );
        (get(headerContent, 'sub_header', ['']) || [1]).map(
          (subHeaderContent) => {
            subHeader.push(<td align="center">{subHeaderContent}</td>);
          }
        );
      });
      mainHeader.push(
        <td
          align="center"
          colSpan={colspan}
          rowSpan={isNull(get(x, 'header')) ? 3 : 1}
        >
          {x.header_title}
        </td>
      );
    });

    data.detail.map((y) => {
      let eachRow = [];
      y.map((row) => {
        eachRow.push(<td align="center">{row}</td>);
      });
      details.push(<tr align="center">{eachRow}</tr>);
    });

    return (
      <table>
        <thead>
          <tr>{mainHeader}</tr>
          <tr>{header}</tr>
          <tr>{subHeader}</tr>
        </thead>
        <tbody>{details}</tbody>
      </table>
    );
  };

  const populateSubjectGraph = () => {
    const graph = [];
    const groupedData = isFetching ? [] : groupBy(analysisGraph, 'SubjectName');
    const subjects = isFetching
      ? [1, 1, 1]
      : !isEmpty(groupedData)
      ? Object.keys(groupedData)
      : [];
    !isEmpty(subjects) &&
      subjects.map((subject, index) => {
        subject !== 'TOTAL' &&
          graph.push(
            <Grid item xs={12} sm={6} md={4} key={index}>
              <div className="slider-graph-container">
                <h4 className="graph-cards-heading">
                  {isFetching ? <Skeleton /> : subject}
                </h4>
                {isFetching ? (
                  <Skeleton variant="rect" height="200px" />
                ) : (
                  <LineGraphsSlider analysisGraph={getGraphData(subject)} />
                )}
              </div>
            </Grid>
          );
      });
    return graph;
  };

  const getGraphData = (label) => {
    const groupedData = groupBy(analysisGraph, 'SubjectName');
    const dataToPopulate = !isEmpty(groupedData) ? groupedData[label] : [];
    const values = [];
    !isEmpty(dataToPopulate) &&
      dataToPopulate.map((row) => {
        values.push({
          date: dateFormat(row.TestDate),
          testPercent: row.TestPercent,
        });
      });
    return values;
  };

  return (
    <div className="print-report">
      <h1 className="test-title">Student Performance Report</h1>
      <div id="section-to-print" className="questions-container">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4} md={6} lg={4}>
            <div className="section">
              <h3 className="heading">Student Personal Detail</h3>
              <div className="profile-header">
                <div className="image-wrapper">
                <img
                  src={ProfilePhoto}
                  className="profile-photo"
                  alt={FullName}
                />
                </div>
                <div className="profile-detail">
                  <ListItem>
                    <ListItemText
                      className="titles"
                      secondary={`Student Name: `}
                    />
                    <ListItemText secondary={`${FullName}`} />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      className="titles"
                      secondary={`App Form No: `}
                    />
                    <ListItemText secondary={`${personal.ApplicationFormNo}`} />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      className="titles"
                      secondary={`Campus Name: `}
                    />
                    <ListItemText secondary={`${batch.CampusName}`} />
                  </ListItem>
                  <ListItem>
                    <ListItemText className="titles" secondary={`Phase: `} />
                    <ListItemText secondary={`${batch.Phase}`} />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      className="titles"
                      secondary={`Batch Name: `}
                    />
                    <ListItemText secondary={`${batch.BatchName}`} />
                  </ListItem>
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={8} md={6} lg={8}>
            <div className="section page-break-after attendance">
              <h3 className="heading">Students Attendance Record</h3>
              {!isEmpty(TableData) || isFetching ? (
                <AttendanceComponent
                  tableData={TableData}
                  isFetching={isFetching}
                />
              ) : (
                <div className="card content-card score-table-container">
                  <NoData
                    message={
                      !isEmpty(ErrorMessage)
                        ? ErrorMessage
                        : 'For Online ADC watch, attendance feature will be started after few weeks.'
                    }
                  />
                </div>
              )}
            </div>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <div className="section pt-20 mb-30 page-break overall">
              <h3 className="heading">Overall Performance Record</h3>
              {isFetching ? (
                <Skeleton variant="rect" height="100px" />
              ) : (
                <>{populateFullTable()}</>
              )}
            </div>
          </Grid>
        </Grid>
        <div className="section">
          <h3 className="heading">Subject Performance Analysis</h3>
          <div className="card content-card slider-container">
            {!isEmpty(analysisGraph) || isFetching ? (
              <Grid container spacing={2}>
                {populateSubjectGraph()}
              </Grid>
            ) : (
              <NoData
                message={
                  !isEmpty(ErrorMessage)
                    ? ErrorMessage
                    : 'As of now, No Subject Charts are available'
                }
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
